import React, { useState } from "react";
import { Toolbar, IconButton, AppBar, Menu, MenuItem, Divider, Avatar, Paper } from "@mui/material";
import { AccountCircle as AccountCircleIcon, Logout as LogoutIcon } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { Menu as MenuIcon } from "@mui/icons-material";
import i18n from "i18next";
import { AuthContext } from "context/AuthContext";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuItems } from "../Drawer/MenuData"
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const Header = ({ actionMenu }) => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const location = useLocation()
  const usr = JSON.parse(localStorage.getItem('mqadusr'))
  const [dataPage, setDataPage] = useState(null)

  const drawerWidth = usr.company !== undefined ? "251px" : "0px";

  const useStyles = makeStyles((theme) => ({
    appBar: {
      [theme.breakpoints.up('md')]: {
        width: `calc(100% - ${drawerWidth}) !important`,
        marginLeft: drawerWidth,
      },
    },
    menuButton: {
      marginLeft: `${theme.spacing(0.5)} !important`,
      marginRight: `${theme.spacing(2)} !important`,
      [theme.breakpoints.up('md')]: {
        display: 'none !important',
      },
    },
  }))

  const classes = useStyles()
  const { logOut } = useContext(AuthContext)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleSetTitleIconPage()
  }

  const handleSelectAccount = () => {
    const user = JSON.parse(localStorage.getItem('mqadusr'))
    delete user.company
    localStorage.setItem('mqadusr', JSON.stringify(user))
    navigate("/admin/account")
  }

  useEffect(() => {
    handleSetTitleIconPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  const handleSetTitleIconPage = () => {
    const data = MenuItems(t)
    const findData = data.find((item) => item.to === location.pathname)
    setDataPage(findData)
    console.log("handleSetTitleIconPage", findData)
  }

  //handleSetTitleIconPage()

  return (<>
    <AppBar position="fixed" className={classes.appBar} color="abbBar">
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={actionMenu}
          className={classes.menuButton} >
          <MenuIcon />
        </IconButton>
        <div style={{ flexGrow: 1 }}>
          {dataPage === null || dataPage === undefined ? "InteliQR Menu" :
            <div style={{ display: "flex", alignItems: "center" }}>
              <Paper elevation={3} sx={{ padding: 1, border: "1px solid #212145", display: "flex", marginRight: 1, borderRadius: "50px" }}>
                {dataPage.icon}
              </Paper>
              <div style={{ marginRight: 8, fontWeight: 700, fontSize: 20 }}>{dataPage.text}</div>
              {/* {usr.company !== undefined ? <BranchOfficeSelect /> : null} */}
            </div>
          }
        </div>
        <div>
          <IconButton
            onClick={handleClick}
            size="small"
            color="inherit"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <AccountCircleIcon />
          </IconButton>
        </div>
      </Toolbar>
    </AppBar>
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 12,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <MenuItem>
        Profile
      </MenuItem>
      {usr.company !== undefined ?
        <MenuItem onClick={() => handleSelectAccount()}>
          Cuentas
        </MenuItem>
        : null}
      <Divider />
      {i18n.language === "en" ?
        <MenuItem onClick={() => changeLanguage('es')}>
          <Avatar alt="Spanish" src="https://cdn-icons-png.flaticon.com/512/323/323365.png" /> Español
        </MenuItem>
        : null}
      {i18n.language === "es" ?
        <MenuItem onClick={() => changeLanguage('en')}>
          <Avatar alt="English" src="https://cdn-icons-png.flaticon.com/512/323/323329.png" /> Inglés
        </MenuItem>
        : null}
      <Divider />
      <MenuItem onClick={logOut}>
        <LogoutIcon /> &nbsp; Logout
      </MenuItem>
    </Menu>
  </>);
};

export default Header;